import React, { useEffect, useState } from 'react'

import { ThemeSwitcher, ButtonRed, ButtonPink, ButtonGrey } from '../../components/common/Button'
import {GenderButton} from '../../components/auth'
import { useHistory } from 'react-router-dom'


import { createUser } from '../../api/auth'

export default function CIntermediate() {
    const [genderConfirmed, setGenderConfirmed] = useState(false)
    const [gender, setGender] = useState(-1)
    const [loadingData, setLoadingData] = useState(false)
    const history = useHistory();
    
    const [userData, setUserdata] = useState({
        email: "",
        password: "",
        displayName: "",
        userType: 1,
        username: "",
        gender: -1,
        tags: []
    })
    

    const handleSelection = (e) => {
        // console.log(e);
        setGender(e);
        // console.log(userData);
        setUserdata({ email: userData.email, password: userData.password, displayName: userData.displayName, userType: userData.userType, username: userData.username, gender: e, tags: [] })
    }

    useEffect(() => {
        if(gender !== -1){
            setGenderConfirmed(true)
        } else {
            setGenderConfirmed(false)
        }
    }, [gender])

    const handleCreatorRegister = async () => {
        try {
            history.push({
                pathname: '/creator-tags',
                state: { email: userData.email, password: userData.password, displayName: userData.displayName, userType: userData.userType, username: userData.username, gender: userData.gender, tags: [] }
            })
        } catch (e) {
            // error handling and other msgs here
            setLoadingData(false);
        }
    }

    useEffect(() => {
        const historyData = history.location.state;
        if (historyData) {
            setUserdata(historyData);
            // console.log(userData)
        }
    }, [])

    const goBack = () => {
        history.push({
            pathname: '/register',
            state: { email: userData.email, password: userData.password, displayName: userData.displayName, userType: userData.userType, username: userData.username, gender: userData.gender, tags: userData.tags }
        })
    }

    return (
        <div className="lover-auth-intermediate">
            <ThemeSwitcher />
            <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logo.svg')} />
            <h5 className="lover-auth-intermediate-header" >What’s your gender?</h5>
            <p className="lover-auth-intermediate-desc">To identify what's type of content you'll create, we need to know your gender. This will help Lovrs to have relevant content on their feed.</p>

            <div className="lover-auth-intermediate-action">
                <GenderButton
                    mActiveIcon="male.svg"
                    mIcon="maleinactive.svg"
                    mText="Male"

                    fActiveIcon="female.svg"
                    fIcon="femaleinactive.svg"
                    fText="Female"

                    handleClick={handleSelection}
                />

                {genderConfirmed ? <ButtonRed icon="tick.svg" handleOnClick={handleCreatorRegister} text={loadingData ? "Please Wait" : "CONFIRM"} /> : <ButtonGrey icon="tick.svg" text="CONFIRM"/>}
                <ButtonPink text="BACK" handleOnClick={goBack}/>
            </div>
        </div>
    )
}
